export default "__VITE_ASSET__CuG1MGnC__"